<template>
  <div class="wrapper">
    <side-bar
      type="sidebar"
      :sidebar-links="$sidebar.sidebarLinks"
    >
      <user-menu />
    </side-bar>

    <div class="main-panel">
      <top-navbar />

      <dashboard-content @click="toggleSidebar" />

      <content-footer />
    </div>
  </div>
</template>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import UserMenu from "@components/UIComponents/SidebarPlugin/UserMenu.vue";

export default {
  components: {
    ContentFooter,
    DashboardContent,
    UserMenu,
    TopNavbar
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  }
};
</script>

<style lang="scss"></style>
